export const globalSearch = {
  state: {
    searchString: '',
  },
  actions: {
    chnageSearchString(context, payload) {
      context.commit('setSearchString', payload)
    }
  },
  mutations: {
    setSearchString: function (state, payload) {
      state.searchString = payload
    }
  },
  getters: {
    getSearchString: function (state) {
      return state.searchString
    }
  }
}
  